"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const tools_1 = require("../tools");
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
const signIn_graphql_1 = tslib_1.__importDefault(require("../gql/users/mutations/signIn.graphql"));
const verifyEmail_graphql_1 = tslib_1.__importDefault(require("../gql/users/mutations/verifyEmail.graphql"));
class Login extends BaseModel_1.default {
    defaults() {
        return {
            email: tools_1.isDev() ? '' : '',
            password: tools_1.isDev() ? '' : '',
        };
    }
    submit() {
        const { email, password } = this;
        return this.mutate(signIn_graphql_1.default, {
            authCredentials: {
                email,
                password,
            },
        });
    }
    verifyEmail() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate(verifyEmail_graphql_1.default, {
                token: this.token,
            });
        });
    }
}
exports.default = Login;
//# sourceMappingURL=Login.js.map